<form [formGroup]="form" class="grid grid-cols-12 flex-col gap-10">
    <section class="col-span-12">
        <span class="text-tertiary-900 text-2xl text-justify block"
            >I request EWA complete the application, verify its accuracy,
            conduct the frequency selection and coordination, and submit it to
            the FCC for license processing. EWA and any associated FCC
            <a
                class="text-blue-600 underline hover:text-blue-800"
                href="https://www.enterprisewireless.org/service-fees"
                target="_blank"
                rel="noopener noreferrer"
                >fees apply</a
            >. (This is the Cevo <strong>"Express"</strong> service.)</span
        >
        <p class="text-tertiary-900 italic text-xl pt-6">
            To help expedite processing, please review the existing applicant
            information and confirm that at least one of the fields below is
            complete.
        </p>
    </section>
    <section class="col-start-2 col-span-10 flex flex-col w-full">
        <mat-form-field
            class="w-full lg:w-10/12 xl:w-6/12"
            appearance="outline"
        >
            <mat-label>Applicant Legal Entity Name</mat-label>
            <input
                title="Applicant Legal Entity Name"
                matInput
                formControlName="licenseeEntityName"
                [appRegexInput]="
                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                "
                maxLength="200"
            />
        </mat-form-field>
        <div class="relative select-none !m-0">
            <div
                class="absolute -left-7 -top-[55px] flex flex-col items-center space-y-9"
            >
                <img
                    src="assets/svg/vertical-line-top-curve-right-lg.svg"
                    alt="or top bracket"
                    aria-hidden="true"
                />
                <div class="text-tertiary-600 mr-3" aria-label="or">Or</div>
                <img
                    src="assets/svg/vertical-line-top-curve-right-lg.svg"
                    alt="or bottom bracket"
                    aria-hidden="true"
                    class="scale-y-[-1]"
                />
            </div>
        </div>
        <div class="w-full lg:w-10/12 xl:w-6/12">
            <span class="text-sm text-tertiary-900"
                >If filing as an individual:</span
            >
            <div class="grid grid-cols-12 gap-5 mt-2">
                <mat-form-field class="col-span-6" appearance="outline">
                    <mat-label>Applicant First Name</mat-label>
                    <input
                        title="Applicant First Name"
                        matInput
                        formControlName="licenseeFirstName"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="20"
                    />
                </mat-form-field>
                <mat-form-field class="col-span-6" appearance="outline">
                    <mat-label>Applicant Last Name</mat-label>
                    <input
                        title="Applicant Last Name"
                        matInput
                        formControlName="licenseeLastName"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="20"
                    />
                </mat-form-field>
            </div>
        </div>
        <mat-form-field class="w-full lg:w-5/12 xl:w-3/12" appearance="outline">
            <mat-label>FCC Registration Number</mat-label>
            <input
                title="FCC Registration Number"
                matInput
                formControlName="fccRegistrationNumber"
                [appRegexInput]="regExPattern.NumericOnly"
                maxLength="10"
                (blur)="padFrnString(form.controls.fccRegistrationNumber.value)"
            />
        </mat-form-field>
        <mat-form-field class="w-full lg:w-5/12 xl:w-3/12" appearance="outline">
            <mat-label>Tax ID Number</mat-label>
            <input
                title="Tax ID Number"
                matInput
                formControlName="taxIdNumber"
                [appRegexInput]="regExPattern.NumericOnly"
                maxLength="9"
            />
        </mat-form-field>
    </section>
    <section class="col-span-12">
        <span class="text-tertiary-900 text-2xl text-justify"
            >Please add/edit any comments regarding your application for the EWA
            Advisor to review.</span
        >
    </section>
    <section class="col-start-2 col-span-10 flex flex-col w-full">
        <mat-form-field
            appearance="outline"
            class="w-full lg:w-10/12 xl:w-6/12"
        >
            <mat-label>Notes</mat-label>
            <textarea
                formControlName="notes"
                title="Notes"
                matInput
                maxlength="1000"
                [appRegexInput]="
                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                "
                class="!h-40 !resize-none"
            ></textarea>
        </mat-form-field>
    </section>
    <section class="lg:col-start-3 lg:col-span-8 col-span-12 w-full">
        <app-submit-to-ewa-form-submission
            [disableSubmission]="!enableSubmission()"
            (submitForm)="handoverToEwaSubmission()"
        ></app-submit-to-ewa-form-submission>
    </section>
</form>
